const giorni = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];
const mesi = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

export const formatDateRange = (date1: Date | null, date2: Date | null): string => {
  if (!date1 && !date2) return 'Seleziona intervallo';
  if (!date1 || !date2) {
    // Se solo una data è presente, formatta solo quella o indica incompletezza
    const d = date1 || date2;
    if (d) {
        return `da ${giorni[d.getDay()]} ${String(d.getDate()).padStart(2, '0')} ${mesi[d.getMonth()]} ${String(d.getFullYear()).slice(-2)} (incompleto)`;
    } 
    return 'Selezione incompleta';
  }

  const d1_giornoSett = giorni[date1.getDay()];
  const d1_giornoNum = String(date1.getDate()).padStart(2, '0');
  const d1_mese = mesi[date1.getMonth()];
  const d1_anno = String(date1.getFullYear()).slice(-2);

  const d2_giornoSett = giorni[date2.getDay()];
  const d2_giornoNum = String(date2.getDate()).padStart(2, '0');
  const d2_mese = mesi[date2.getMonth()];
  const d2_anno = String(date2.getFullYear()).slice(-2);

  // Caso 1: Stesso giorno, mese e anno
  if (d1_anno === d2_anno && d1_mese === d2_mese && d1_giornoNum === d2_giornoNum) {
    return `${d1_giornoSett} ${d1_giornoNum} ${d1_mese} ${d1_anno}`;
  }

  // Caso 2: Stesso mese e anno, giorno diverso
  if (d1_anno === d2_anno && d1_mese === d2_mese) {
    return `${d1_giornoSett} ${d1_giornoNum} - ${d2_giornoSett} ${d2_giornoNum} ${d1_mese} ${d1_anno}`;
  }

  // Caso 3: Stesso anno, mese diverso (e giorno potenzialmente diverso)
  if (d1_anno === d2_anno) {
    return `${d1_giornoSett} ${d1_giornoNum} ${d1_mese} - ${d2_giornoSett} ${d2_giornoNum} ${d2_mese} ${d1_anno}`;
  }

  // Caso 4: Anni diversi (e quindi anche mesi e giorni potenzialmente diversi)
  return `${d1_giornoSett} ${d1_giornoNum} ${d1_mese} ${d1_anno} - ${d2_giornoSett} ${d2_giornoNum} ${d2_mese} ${d2_anno}`;
}; 